// extracted by mini-css-extract-plugin
export default {"redirectPage":"home_redirectPage__LUq4o","redirectPageDisplay":"home_redirectPageDisplay__C-Ahc"};